import { render } from "./ExperienceCard.vue?vue&type=template&id=60d2778f&scoped=true"
import script from "./ExperienceCard.vue?vue&type=script&lang=js"
export * from "./ExperienceCard.vue?vue&type=script&lang=js"

import "./ExperienceCard.vue?vue&type=style&index=0&id=60d2778f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60d2778f"]])

export default __exports__